import(/* webpackMode: "eager" */ "/vercel/path0/src/app/quantum-readiness/page.tsx");
